import React from 'react'

import LandingHeaderComponent from '../../components/LandingHeaderComponent'

const LoginLayout = (props) => {
  return (
		<div className="login-layout overflow-auto">
			{/* <LandingHeaderComponent /> */}
			{ props.children }
		</div>
  )
}

export default LoginLayout
